export default "__VITE_ASSET__phbk0OxG__"